export default function Benefits() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-28 bg-[#E91E63]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black text-center mb-10 sm:mb-12 lg:mb-16">
          Benefícios da Depilação a Laser
        </h2>

        {/* Comparison */}
        <div className="mb-16">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-6 sm:mb-8">
            Depilação a Laser x Métodos Tradicionais
          </h3>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {/* Traditional Methods */}
            <div className="bg-white/60 rounded-2xl p-6 sm:p-8 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-red-500 rounded-full mt-1">
                  <i className="ri-close-line text-white text-sm"></i>
                </div>
                <p className="text-gray-700">Lâmina: pelos grossos, escuros e retorno rápido</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-red-500 rounded-full mt-1">
                  <i className="ri-close-line text-white text-sm"></i>
                </div>
                <p className="text-gray-700">Cera: dor, irritação e pelos encravados</p>
              </div>
            </div>

            {/* Laser Method - Highlighted */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-4 border-[#E91E63] shadow-xl transform md:scale-105">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-[#E91E63] rounded-full mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-black font-semibold">Laser: redução progressiva, conforto e praticidade</p>
              </div>
            </div>
          </div>
        </div>

        {/* Results Grid */}
        <div className="mb-12">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-6 sm:mb-8 text-center">
            Resultados que transformam sua rotina
          </h3>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {[
              { icon: 'ri-calendar-check-line', text: 'Menos sessões ao longo do tempo' },
              { icon: 'ri-heart-pulse-line', text: 'Pele mais lisa e uniforme' },
              { icon: 'ri-money-dollar-circle-line', text: 'Economia a médio e longo prazo' }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#E91E63] rounded-full flex-shrink-0">
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                  <p className="text-black font-medium">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Confidence Section */}
        <div className="bg-white rounded-2xl sm:rounded-3xl p-8 sm:p-10 md:p-12 shadow-xl max-w-4xl mx-auto text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-[#E91E63] rounded-full mx-auto mb-6">
            <i className="ri-star-smile-line text-white text-4xl"></i>
          </div>
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-4">
            Mais confiança e liberdade
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed">
            Use o que quiser, quando quiser — sem se preocupar com pelos, marcas ou irritações.
          </p>
        </div>
      </div>
    </section>
  );
}
